import AppConstants from '../config/app.constants';

let ShiptypeService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/shiptype`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/shiptype/create`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/shiptype/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId, changedObj) => {
        return $http
            .post(AppConstants.api + `/shiptype/${id}`, { data, branchId,changedObj })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/shiptype/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

ShiptypeService.$inject = ['$http', '$q']

export default ShiptypeService;



// WEBPACK FOOTER //
// ./client/app/services/shiptype.service.js